import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// Import nprogress CSS at the root such that any component may call NProgress.
import "nprogress/nprogress.css";
import firebase from "firebase";

import Login from "./containers/Login";
import Logout from "./containers/Logout";
import NoMatch from "./containers/NoMatch";
import Page from "./containers/Page";
import Wiki from "./services/wiki";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null
    };

    const firebaseConfig = {
      apiKey: "AIzaSyBamwCK2urLO3YtBTdPJ-IXUzbt-9Zn-2o",
      authDomain: "mx-wiki.firebaseapp.com",
      databaseURL: "https://mx-wiki.firebaseio.com",
      projectId: "mx-wiki",
      storageBucket: "mx-wiki.appspot.com",
      messagingSenderId: "338876311276"
    };
    firebase.initializeApp(firebaseConfig);

    this.wiki = new Wiki(firebase.database());
  }

  componentWillMount() {
    // Attach observer for getting authentication state
    firebase.auth().onAuthStateChanged(user => {
      this.setState({ user: user });
    });
  }

  render() {
    /** Wrapper for render function that also accepts a mode. */
    const PageRender = (mode, props) =>
      <Page wiki={this.wiki} mode={mode} user={this.state.user} {...props} />;

    return (
      <Router>
        {/* Container class used for bootstrap */}
        <div className="App container">
          <Switch>
            <Route
              exact
              path="/"
              render={props => {
                return PageRender(Page.Mode.SHOW, props);
              }}
            />

            <Route exact path="/login" component={Login} />
            <Route exact path="/logout" component={Logout} />

            {/* Must come before the show catch-all. */}
            <Route
              exact
              path="/:name+/_edit"
              render={props => {
                return PageRender(Page.Mode.EDIT, props);
              }}
            />
            <Route
              exact
              path="/:name+"
              render={props => {
                return PageRender(Page.Mode.SHOW, props);
              }}
            />
            <Route component={NoMatch} />
          </Switch>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js